export default __webpack_public_path__ + "static/media/NaturalConvectionTableImg.8f031e43.png";